module.exports = __webpack_public_path__ + "img/card_sarria_background.7be17efc.png";